// extracted by mini-css-extract-plugin
module.exports = {"EventStatus":"EventStatus_EventStatus__cWBAl"};